import {Dialog, Transition} from "@headlessui/react";
import React, {Fragment, useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import saveItem, { getItem, getList} from "../../services/service";
import {selectUser} from '../../features/user/userSlice';
import SelectComponent from '../SelectComponent';
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";

const ModalPrice = ({open, setOpen, productId, groupType, fetchData, rowId, selectedCountryId}) => {
    const toDay = new Date().toISOString().substring(0, 10);
    const cancelButtonRef = useRef(null);
    const [textures, setTextures] = useState([])
    const [currencies, setCurrencies] = useState([])
    const [countries, setCountries] = useState([])
    const [data, setData] = useState({
        id:  null,
        productId: productId,
        textureId: null,
        countryId: selectedCountryId || null,
        price: "",
        date: toDay
    })

    const {token} = useSelector(selectUser);
    const {t} = useTranslation();
    const navigate = useNavigate();
    const getTexturesList = async () => {
        if (open) {
            let jsonTexture = await getList(`${process.env.REACT_APP_HOST_BASE_URL}/v1/texture/list`, token);
            let reviewData = jsonTexture?.data.map((item) => {
                return {
                    id: item.id,
                    name: (
                        <div className="flex w-full">
                            <div className="w-full">{item.name}</div>
                            <div
                                style={{backgroundColor: `${item.color}`}}
                                className={`w-[60px] rounded-lg border-2 right-0`}
                            >
                            </div>
                        </div>
                    ),
                };
            });
            setTextures(reviewData);
        }
    };
    const getCurrencyList = async () => {
        if (open) {
            let jsonTexture = await getList(`${process.env.REACT_APP_HOST_BASE_URL}/v1/currency/list`, token);
            setCurrencies(jsonTexture?.data);
        }
    };
    const getCountryList = async () => {
        if (open) {
            let res = await getList(`${process.env.REACT_APP_HOST_BASE_URL}/v1/country/list`, token);
            setCountries(res?.data || []);
        }
    };


    const fetchDataById = async () => {
        const response = await getItem(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/price/${rowId}`,
            token
        );
        if (response?.success) {
            setData((prev)=>{
                return {
                    ...prev,
                    price: response.data.price,
                    priceOfOne: response.data.priceOfOne,
                    date: response.data.date,
                    textureId: response.data.textureId,
                    currencyId: response.data.currencyId,
                    countryId: response.data.countryId,
                    id:response.data.id,
                    productId: response.data.productId
                }
            })
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };
    useEffect(() => {
        if(rowId){
            fetchDataById().then(()=> {
                getTexturesList();
                getCurrencyList();
                getCountryList();
            })
        } else{
            setData({
                id:  null,
                productId: productId,
                textureId: null,
                currencyId: null,
                countryId: selectedCountryId || null,
                price: "",
                priceOfOne: "",
                date: toDay,
            })

            getTexturesList();
            getCurrencyList();
            getCountryList();

        }
        setTextures([])
    }, [open])

    const handleSave = async (e) => {
        e.preventDefault()
        if (data !== null) {
            const url = `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/price`
            const res = await saveItem(url, token, data);
            if (res.success) {
                fetchData();
                setData((prev) => {
                    return {
                        ...prev,
                        date: toDay,
                        textureId: textures,
                        price: "",
                        priceOfOne: ""
                    }
                })
                setOpen(false);
                if(rowId){
                    toast.success(t('action.edit_success'), {
                        position: "bottom-right",
                        autoClose: 3000,
                        closeOnClick: true,
                        className: "add-success"
                    });
                }else{
                    toast.success(t('action.add_success'), {
                        position: "bottom-right",
                        autoClose: 3000,
                        closeOnClick: true,
                        className: "add-success"
                    });
                }
            } else {
                console.log(`error`, res.message);
            }
        }
    }

    const onChangeTexture = (value) => {
        setData((prev) => {
            return {
                ...prev, textureId: value.id
            }
        })
    };
    const onChangeCurrency = (value) => {
        setData((prev) => {
            return {
                ...prev, currencyId: value.id
            }
        })
    };
    const onChangeCountry = (value) => {
        setData((prev) => {
            return {
                ...prev, countryId: value.id
            }
        })
    };

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-10"
                initialFocus={cancelButtonRef}
                onClose={setOpen}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"/>
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className="relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-[30%] sm:w-full sm:p-6">
                                <div>
                                    <div className="">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-medium leading-6 text-gray-900"
                                        >
                                            {t('add_price')}
                                        </Dialog.Title>
                                        <form className="mt-8" onSubmit={handleSave}>
                                            <div
                                                className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                                                {productId != null ? (
                                                  <>
                                                      <div className="col-span-6 sm:col-span-3">
                                                          <label
                                                            htmlFor="drawing"
                                                            className="block text-sm font-medium text-gray-700"
                                                          >
                                                              {t('date')}
                                                          </label>
                                                          <input
                                                            type="date"
                                                            name="date"
                                                            id="date"
                                                            required
                                                            value={data?.date}
                                                            onChange={(e) => {
                                                                setData((prev) => {
                                                                    return {
                                                                        ...prev,
                                                                        date: e.target.value
                                                                    }
                                                                })
                                                            }}
                                                            className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                          />
                                                      </div>
                                                      <div className="col-span-6 sm:col-span-3">
                                                          <SelectComponent
                                                            data={textures}
                                                            title={t('textures')}
                                                            item={data ? textures?.find(ti => ti.id === data?.textureId) : null}
                                                            onchange={onChangeTexture}
                                                          />
                                                      </div>
                                                      <div className="col-span-6 sm:col-span-3">
                                                          <label
                                                            htmlFor="price"
                                                            className="block text-sm font-medium text-gray-700"
                                                          >
                                                              {t('price')}
                                                          </label>

                                                          <input
                                                            type="number"
                                                            name="price"
                                                            id="price"
                                                            required
                                                            autoComplete="price"
                                                            step={1}
                                                            value={data?.price}
                                                            onChange={(e) => {
                                                                setData((prev) => {
                                                                    return {
                                                                        ...prev,
                                                                        price: e.target.value
                                                                    }
                                                                })
                                                            }}
                                                            className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                          />
                                                      </div>
                                                      <div className="col-span-6 sm:col-span-3">
                                                          <label
                                                            htmlFor="priceOfOne"
                                                            className="block text-sm font-medium text-gray-700"
                                                          >
                                                              {t('priceOfOne')}
                                                          </label>

                                                          <input
                                                            type="number"
                                                            name="priceOfOne"
                                                            id="priceOfOne"
                                                            required
                                                            autoComplete="priceOfOne"
                                                            step={1}
                                                            value={data?.priceOfOne}
                                                            onChange={(e) => {
                                                                setData((prev) => {
                                                                    return {
                                                                        ...prev,
                                                                        priceOfOne: e.target.value
                                                                    }
                                                                })
                                                            }}
                                                            className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                          />
                                                      </div>
                                                      <div className="col-span-6 sm:col-span-3">
                                                          <SelectComponent
                                                            data={currencies}
                                                            title={t('currency')}
                                                            item={data ? currencies?.find(ti => ti.id === data?.currencyId) : null}
                                                            onchange={onChangeCurrency}
                                                          />
                                                      </div>
                                                      <div className="col-span-6 sm:col-span-3">
                                                          <SelectComponent
                                                            data={countries}
                                                            title={t('country')}
                                                            item={data ? countries?.find(c => c.id === data?.countryId) : null}
                                                            onchange={onChangeCountry}
                                                          />
                                                      </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )}
                                            </div>
                                            <div
                                              className="mt-10 sm:mt-10 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                                                <button
                                                  type="submit"
                                                  className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"

                                                >
                                                    {t('save')}
                                                </button>
                                                <button
                                                  type="button"
                                                  className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                                                  onClick={() => setOpen(false)}
                                                  ref={cancelButtonRef}
                                                >
                                                    {t('cancel')}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

export default ModalPrice
